module.exports = __webpack_public_path__ + "static/favicon-79725175605e50d666af329da8dc36cd.ico";